import React, {Component} from 'react';
import {Modal, ModalBody, ModalFooter, ModalHeader} from 'reactstrap';
import {API_URL} from "../../settings/local_settings";
import {APIClient} from "../../utils/APIClient";
import {Spinner} from "../Spinner";
import { withTranslation } from 'react-i18next';
import {Plus} from '@phosphor-icons/react';

class AddClientForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            saving: false,
        };
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    handleSubmit(event) {
        event.preventDefault();
        this.setState({saving: true});
        let submit_url = API_URL + 'client/add';
        const clientName = event.target.clientname.value;
        new APIClient(submit_url).call('POST', {'name': clientName}).then((data) => {
            this.setState({saving: false});
            if (data.status === 'ERROR') {
                alert(data['error_message']);
            } else if (data.status === 'OK') {
                this.props.onClientAdded(data.data, clientName)
            }
        })
    }

    renderSaveButton() {
        const { t } = this.props;
        if (!this.state.saving) {
            return <input type="submit" value={t('add_client.add_button')} className="btn -submit"/>
        } else {
            return <Spinner color="positive small"/>;
        }
    }

    render() {
        const { t } = this.props;
        return (
            <form onSubmit={this.handleSubmit}>
                <ModalBody>
                    <div className="modal-section">
                        <div className="form-row">
                            <label>{t('add_client.name_label')}</label>
                            <input name="clientname" type="text" required="required"/>
                        </div>
                    </div>
                </ModalBody>
                <ModalFooter>
                    {this.renderSaveButton()}
                </ModalFooter>
            </form>
        )
    }
}

class AddClientModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            modal: false
        };

        this.toggle = this.toggle.bind(this);
        this.handleFormSubmitted = this.handleFormSubmitted.bind(this);
    }

    toggle() {
        this.setState({
            modal: !this.state.modal
        });
    }

    handleFormSubmitted(newClientId, newClientName) {
        this.toggle();
        this.props.onClientAdded(newClientId, newClientName);
    }

    render() {
        const { t } = this.props;
        return (
            <div>
                {this.renderButton()}
                <Modal isOpen={this.state.modal} toggle={this.toggle} className={this.props.className}>
                    <ModalHeader toggle={this.toggle}>{t('add_client.modal_title')}</ModalHeader>
                    <TranslatedAddClientForm closeModal={this.toggle} onClientAdded={this.handleFormSubmitted}/>
                </Modal>
            </div>
        );
    }

    renderButton() {
        const { t } = this.props;
        return this.props.showButton ? (
            <button className="client-cards-add-btn" onClick={this.toggle}>
                <Plus size={16} weight="bold"/> {t('client_cards.new_client')}
            </button>
        ) : null;
    }
}

const TranslatedAddClientForm = withTranslation()(AddClientForm);
const TranslatedAddClientModal = withTranslation()(AddClientModal);

export { TranslatedAddClientForm as AddClientForm, TranslatedAddClientModal as AddClientModal };
